/**
 * Standard browser navigation helpers — Ctrl/Cmd/middle-click → new tab.
 */

/** True when the event should open the destination in a new tab. */
export function shouldOpenInNewTab(event) {
    if (!event) return false;
    // Middle mouse button
    if (event.button === 1) return true;
    // Ctrl (Win/Linux) or Meta/Cmd (macOS) + primary click
    if (event.type === 'click' || event.type === 'auxclick') {
        return Boolean(event.metaKey || event.ctrlKey || event.shiftKey);
    }
    return false;
}

/** Absolute or app-relative path suitable for window.open / <a href>. */
export function toAppHref(to) {
    if (!to) return '';
    if (/^https?:\/\//i.test(to)) return to;
    const path = to.startsWith('/') ? to : `/${to}`;
    if (typeof window === 'undefined') return path;
    return `${window.location.origin}${path}`;
}

/** Open an in-app route in a new browser tab. */
export function openInNewTab(to) {
    const href = toAppHref(to);
    if (!href) return;
    window.open(href, '_blank', 'noopener,noreferrer');
}

/**
 * Handle a navigation click with standard browser semantics.
 * @returns {'new-tab'|'navigate'|'ignored'}
 */
export function handleNavClick(event, to, navigate) {
    if (!to) return 'ignored';
    if (shouldOpenInNewTab(event)) {
        event.preventDefault?.();
        event.stopPropagation?.();
        openInNewTab(to);
        return 'new-tab';
    }
    if (typeof navigate === 'function') {
        event?.preventDefault?.();
        navigate(to);
        return 'navigate';
    }
    return 'ignored';
}
